import type { MetricsResponse } from '@/common/api/models/metricsResponse';

import denseMetricsDocument from './denseMetrics.json';

/** Matches `DENSE_DATE_FROM` / `DENSE_DATE_TO` in dense_lab_fixture_builder.py. */
export const DENSE_LAB_FILTER_FROM = denseMetricsDocument.context.filters.from as string;
export const DENSE_LAB_FILTER_TO = denseMetricsDocument.context.filters.to as string;

export function loadDenseLabMetrics(): MetricsResponse {
  return denseMetricsDocument as MetricsResponse;
}
